import * as Api from '@ViewModels';
import moment from 'moment';

export interface ICalendarDropTargetComponentProps {
	droppableType: string;
	onRequestDroppableId?(moment: moment.Moment): string;
}

export interface ICampaignCalendarEventOptions {
	hideApprovalCtas?: boolean;
	showScheduledFor?: boolean;
}

export interface ICampaignCalendarTimeSpanOptions {
	eventOptions?: ICampaignCalendarEventOptions;
	groupEventsByGroupId?: boolean;
}

export interface ICampaignCalendarOptions {
	timeSpanOptions?: ICampaignCalendarTimeSpanOptions;
}

export interface ICalendarTimeSpan {
	blogReports?: Api.IBlogReportView[];
	campaigns?: Api.CampaignViewModel[];
	campaignsByGroupId?: Api.IDictionary<Api.CampaignViewModel[]>;
	moment: moment.Moment;
	socialCampaigns?: Api.SocialMediaPostReportViewModel[];
	title?: string;
	unitOfTime: moment.unitOfTime.Base;
}

export interface ICampaignCalendarEventPlaceholder<T = any> {
	completedDate?: string;
	dataContext?: T;
	moment: moment.Moment;
	schedule?: Api.IScheduledSend;
	status: Api.EmailSendStatus | Api.PostStatus | Api.BlogStatus;
	subject?: string;
}

export type EventDataType =
	| Api.CampaignViewModel[]
	| Api.CampaignViewModel
	| Api.SocialMediaPostReportViewModel
	| Api.IBlogReportView;

export const SelectedPostStatuses = [
	Api.PostStatus.PartiallySucceeded,
	Api.PostStatus.Pending,
	Api.PostStatus.Scheduled,
	Api.PostStatus.Started,
	Api.PostStatus.Succeeded,
];

export const DefaultCampaignCalendarBlogStatuses = [
	Api.BlogStatus.Pending,
	Api.BlogStatus.Queued,
	Api.BlogStatus.Completed,
];
